/*
 * @Author: Nanxing Xiang
 * @Date: 2021-03-05 10:15:02
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2021-09-01 11:49:49
 * @Description: file content
 */
var getDefaultFontSize = () => {
  var d = window.document.createElement('div');
  d.style.width = '1rem';
  d.style.display = 'none';
  var head = window.document.getElementsByTagName('head')[0];
  head.appendChild(d);
  var defaultFontSize = parseFloat(window.getComputedStyle(d, null).getPropertyValue('width'));
  head.removeChild(d);
  return defaultFontSize;
};
export var remfix = (desgin, root) => {
  var defaultFontSize = getDefaultFontSize();
  var docEl = document.documentElement;
  var ratio = desgin / root / 100 * defaultFontSize;
  var handler = () => {
    var {
      clientWidth
    } = docEl;
    if (!clientWidth) return;
    docEl.style.fontSize = "".concat(Math.min(clientWidth, 640) / ratio, "%");
  };
  handler();
  window.addEventListener('resize', handler, false);
  window.addEventListener('orientationchange', handler, false);
  document.addEventListener('DOMContentLoaded', handler, false);
};